(function () {
  'use strict';

  var sections = document.querySelectorAll('[data-short-reels]');
  if (!sections.length) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function hydrate(video) {
    if (!video || video.dataset.loaded === 'true') return;

    video.querySelectorAll('source[data-src]').forEach(function (source) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    video.dataset.loaded = 'true';
    video.load();
  }

  function pause(video) {
    if (video && !video.paused) video.pause();
  }

  function setMuted(video, muted) {
    if (!video) return;

    video.muted = muted;
    if (muted) {
      video.setAttribute('muted', '');
    } else {
      video.removeAttribute('muted');
    }
  }

  function isAudioOn(section) {
    return section.dataset.audio === 'on';
  }

  function updateAudioControls(section) {
    var audioOn = isAudioOn(section);
    section.querySelectorAll('[data-short-reels-audio]').forEach(function (button) {
      button.setAttribute('aria-pressed', audioOn ? 'true' : 'false');
      button.setAttribute('aria-label', audioOn ? '音声をオフにする' : '音声をオンにする');
    });
  }

  function toggleAudio(section) {
    var audioOn = !isAudioOn(section);
    var activeIndex = parseInt(section.dataset.activeIndex || '0', 10);
    var videos = section.querySelectorAll('[data-short-reel-video]');
    var activeVideo = videos[activeIndex];

    section.dataset.audio = audioOn ? 'on' : 'off';
    videos.forEach(function (video, index) {
      setMuted(video, !(audioOn && index === activeIndex));
    });
    updateAudioControls(section);

    if (activeVideo) {
      play(activeVideo, section);
    }
  }

  function play(video, section) {
    if (!video) return;

    hydrate(video);
    if (reducedMotion.matches || document.hidden || section.dataset.inView !== 'true') return;

    setMuted(video, !isAudioOn(section));
    video.setAttribute('playsinline', '');

    var promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(function () {});
    }
  }

  function update(section, nextIndex) {
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-short-reels-card]'));
    var videos = Array.prototype.slice.call(section.querySelectorAll('[data-short-reel-video]'));
    var count = cards.length;
    if (!count) return;

    var activeIndex = ((nextIndex % count) + count) % count;
    var prevIndex = (activeIndex + count - 1) % count;
    var nextVisibleIndex = (activeIndex + 1) % count;

    section.dataset.activeIndex = String(activeIndex);

    cards.forEach(function (card, index) {
      var position = 'hidden';
      if (index === activeIndex) position = 'active';
      else if (index === prevIndex) position = 'prev';
      else if (index === nextVisibleIndex) position = 'next';

      card.dataset.position = position;
      card.setAttribute('aria-current', position === 'active' ? 'true' : 'false');
    });

    videos.forEach(function (video, index) {
      if (index === activeIndex) {
        play(video, section);
      } else {
        pause(video);
        setMuted(video, true);
      }
    });

    updateAudioControls(section);
  }

  sections.forEach(function (section) {
    var prevBtn = section.querySelector('[data-short-reels-prev]');
    var nextBtn = section.querySelector('[data-short-reels-next]');

    section.dataset.inView = 'false';
    section.dataset.audio = 'off';
    update(section, 0);
    updateAudioControls(section);

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var current = parseInt(section.dataset.activeIndex || '0', 10);
        update(section, current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var current = parseInt(section.dataset.activeIndex || '0', 10);
        update(section, current + 1);
      });
    }

    section.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

      event.preventDefault();
      var current = parseInt(section.dataset.activeIndex || '0', 10);
      update(section, event.key === 'ArrowRight' ? current + 1 : current - 1);
    });
  });

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-short-reels-audio]') : null;
    if (!button) return;

    var section = button.closest('[data-short-reels]');
    if (!section) return;

    event.preventDefault();
    toggleAudio(section);
  });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var section = entry.target;
        var activeIndex = parseInt(section.dataset.activeIndex || '0', 10);
        var activeVideo = section.querySelectorAll('[data-short-reel-video]')[activeIndex];

        section.dataset.inView = entry.isIntersecting && entry.intersectionRatio >= 0.28 ? 'true' : 'false';

        if (section.dataset.inView === 'true') {
          play(activeVideo, section);
        } else {
          section.querySelectorAll('[data-short-reel-video]').forEach(pause);
        }
      });
    }, {
      root: null,
      rootMargin: '240px 0px',
      threshold: [0, 0.28, 0.7]
    });

    sections.forEach(function (section) {
      observer.observe(section);
    });
  } else {
    sections.forEach(function (section) {
      section.dataset.inView = 'true';
      update(section, parseInt(section.dataset.activeIndex || '0', 10));
    });
  }

  document.addEventListener('visibilitychange', function () {
    sections.forEach(function (section) {
      var activeIndex = parseInt(section.dataset.activeIndex || '0', 10);
      var videos = section.querySelectorAll('[data-short-reel-video]');

      if (document.hidden) {
        videos.forEach(pause);
      } else {
        play(videos[activeIndex], section);
      }
    });
  });
})();
